import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import { io } from "socket.io-client";
import social from "../assets/perks/message.svg";

import { SOCKET_URL } from "../constants/urls";

const music_files = {
    bid: "https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/New+Bid+alert.mp3",
    new: "https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/NFT+Dropped+alert.mp3",
    win: "https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/Auction+Winner+alert.mp3",
};

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 100vh;
    flex-direction: column;
  }
  @media only screen and (min-device-width: 480px) 
                   and (max-device-width: 920px) 
                   and (orientation: landscape) {

    display: flex;
    height: 100vh;
    flex-direction: column;
}
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    opacity: 0.8
    align-items: flex-end;
    padding-left: 50px;
  }
`;


const Title = styled.div`
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 90%;
  /* or 27px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;

  /* Brainfuck */

  text-shadow: 0px 4px 20px rgba(255, 255, 255, 0.4),
    0px 4px 4px rgba(0, 0, 0, 0.1);
  overflow-wrap: anywhere;
`;

const Price = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  display: flex;
  align-items: center;

  color: #ffffff;
`;

const Subtitle = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #9c9c9c;
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  /* or 17px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;

  /* Brainfuck */

  text-shadow: 0px 4px 20px rgba(255, 255, 255, 0.4),
    0px 4px 4px rgba(0, 0, 0, 0.1);
`;


const Box = styled.div`
  clip-path: polygon(100% 0%, 100% 85%, 92% 100%, 0% 100%, 0% 15%, 8% 0%);
  width: 234px;
  background: #000;
  background: linear-gradient(68.93deg, #7748e5 4.36%, #1c77fa 96.41%);
  background: ${(props) =>
    props.winner
      ? "linear-gradient(180deg, #ffd600 0%, #ff7a00 100%)"
      : " linear-gradient(68.93deg, #7748E5 4.36%, #1C77FA 96.41%)"};
  padding: 4px;
  margin-left: 20px;
  margin-top: 12px;
`;

const PurpleBox = styled.div`
  clip-path: polygon(100% 0%, 100% 85%, 92% 100%, 0% 100%, 0% 15%, 8% 0%);
  width: 234px;
  background: #000;
  background: #7c20f9;
  padding: 4px;
  margin-left: 20px;
  margin-top: 12px;
`;

const BoxInner = styled.div`
  width: 100%;
  height: 100%;
  background: ${(props) =>
    props.winner
      ? "rgba(196, 196, 196, 1)"
      : "linear-gradient(180deg, #1024DD 0%, #000855 100%)"};
  clip-path: polygon(100% 0%, 100% 85%, 92% 100%, 0% 100%, 0% 15%, 8% 0%);
  padding: ${(props) => (props.winner ? "0px" : "10px")};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

const PurpleBoxInner = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #2b1941 0%, #220647 75.86%);
  clip-path: polygon(100% 0%, 100% 85%, 92% 100%, 0% 100%, 0% 15%, 8% 0%);
  padding: ${(props) => (props.winner ? "0px" : "10px")};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;

const Text = styled.div`
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  /* or 15px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;
`;

const Bidder = styled.div`
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 145%;
  /* identical to box height, or 15px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;

  /* Brainfuck */

  text-shadow: 0px 4px 20px rgba(255, 255, 255, 0.4),
    0px 4px 4px rgba(0, 0, 0, 0.1);
`;

const Message = styled.div`
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 145%;
  color: #ffffff;
  text-shadow: 0px 4px 20px rgba(255, 255, 255, 0.4),
    0px 4px 4px rgba(0, 0, 0, 0.1);
`;

const TimerTitle = ({ auctionEndingAt }) => {
  const [timer, setTimer] = useState({});

  useEffect(() => {
    setTimeout(async () => {
      let temp_timer = calculateTimeLeft(auctionEndingAt);
      setTimer(temp_timer);
    }, 1000);
  }, [timer]);

  const calculateTimeLeft = (time) => {
    let difference = new Date(time) - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
        show: true,
      };
    }

    return timeLeft;
  };

  let timeLeft = timer;
  // console.log(timeLeft)

  return (
    <>
      {timeLeft && timeLeft.show && (
        <Text style={{ paddingLeft: 6 }}>
          <span style={{ color: "#fff", marginRight: 6 }}>
            {timeLeft.minutes}m {timeLeft.seconds}s
          </span>
        </Text>
      )}
    </>
  );
};

export default function TwitchOverlay(props) {
  const [glips, setGlips] = useState({});
  const [showCard, setShowCard] = useState(true);
  const [auctionEndingAt, setAuctionEndingAt] = useState({});
  const socketInformation = useRef({});

  const [showMessage, setShowMessage] = useState(false);
  const [messageData, setMessageData] = useState({});

  const { username } = useParams();

  const connectSocket = (userName) => {
    const socket = io(SOCKET_URL, {
      // const socket = io('http://localhost:4040/', {
      transports: ["websocket"],
      query: { roomId: `c-${username}` },
    });
    socketInformation.current.username = username;
    socketInformation.current.socket = socket;
    socket.on("connect", () => {
      console.log("socket establishedgg");
      socket.on("message", (data: any) => {
        console.log("data", data);
        if (data.type === "onNewTopBid") {
          let temp = glips;
          temp[data.data.payload.serial] = data.data;
          setGlips({ ...temp });

          // Play music
          var audio = new Audio(music_files.bid);
          audio.play();
        } else if (data.type === "onBidWinBroadcast") {
          console.log("onBidWinBroadcast====================win", data.data);
          let temp = glips;
          temp[data.data.payload.serial] = data.data;
          setGlips({ ...temp });

          setTimeout(() => {
            delete temp[data.data.payload.serial];
            setGlips({ ...temp });
          }, 30000);

          // Play music
          var audio = new Audio(music_files.win);
          audio.play();
        } else if (data.type === "onNewAuction") {
          console.log('"onNewAuction"====================', data.data);
          let temp = glips;
          temp[data.data.payload.serial] = data.data;
          setGlips({ ...temp });

          temp = auctionEndingAt;
          temp[data.data.payload.serial] = data.data.payload.auctionEndingAt;
          console.log(temp);
          setAuctionEndingAt({ ...temp });

          // Play music
          var audio = new Audio(music_files.new);
          audio.play();
        } else if (data.type === "usePerk") {
          switch (data.perksData.perk) {
            case "message":
              // code block
              setMessageData(data.perksData);
              setShowMessage(true);

              // Play music
              var audio = new Audio(music_files.new);
              audio.play();

              setTimeout(() => {
                setShowMessage(false);
              }, 30000);

              break;
            case "y":
              // code block
              break;
            default:
            // code block
          }
        }
      });
      socket.on("data", (data) => {
        console.log(data);
      });
    });

    socket.on("disconnect", (reason) => {
      console.log(socket.id, reason);
      console.log("disconnect gg");
      socketInformation.current.socket = undefined;
      socketInformation.current.userId = undefined;
    });
  };

  useEffect(() => {
    connectSocket(username);

    return () => {
      if (socketInformation.current.socket) {
        socketInformation.current.socket.disconnect();
        socketInformation.current.socket = undefined;
        socketInformation.current.username = undefined;
      }
    };
  }, []);

  const Card = ({ item }) => {
    console.log(item);

    if (item.type == "onNewTopBid")
      return (
        <Box>
          <BoxInner>
            <div
              style={{
                marginBottom: 18,
                display: "flex",
                justifyContent: "center",
                padding: 4,
                background: "rgba(0,0,0,0.3)",
              }}
            >
              <Text>NFT #{item.payload.serial} · </Text>
              <TimerTitle
                setShowCard={setShowCard}
                auctionEndingAt={auctionEndingAt[item.payload.serial]}
              />
            </div>
            <Title style={{ fontSize: 32 }}>
              {item.payload.bidderUserName}
            </Title>
            <Bidder style={{ marginTop: 10 }}>BID {item.payload.currency == 'USD' ? '$' : '₹'}{item.payload.value}</Bidder>
            <Subtitle style={{ marginTop: 10 }}>!glip IN CHAT</Subtitle>
          </BoxInner>
        </Box>
        // <div style={{opacity: 1, padding: 8, paddingTop: 0, margin: 6, background: 'linear-gradient(98.93deg, rgba(0, 0, 0, 0.2) 43.21%, rgba(0, 0, 0, 0) 99.61%), linear-gradient(0deg, #000000, #000000)'}}>
        //     <div style={{display: 'flex', justifyContent: 'space-between'}}>
        //         <Title style={{paddingTop: 6, paddingBottom: 6}}>NFT #{item.payload.serial}</Title>
        //         <TimerTitle auctionEndingAt={auctionEndingAt[item.payload.serial]} />
        //     </div>

        //     <div style={{display: 'flex', marginTop: 6}}>
        //         <Subtitle style={{marginRight: 8, color: 'grey'}}> @{item.payload.bidderUserName} bid </Subtitle>
        //         <Subtitle style={{color: '#fff'}}>${item.payload.value}</Subtitle>
        //     </div>
        // </div>
      );
    else if (item.type == "onBidWinBroadcast")
      return (
        <Box winner={true}>
          <BoxInner winner={true}>
            <div
              style={{
                width: "100%",
                background: "#413321",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                padding: 10,
              }}
            >
              <div
                style={{
                  marginBottom: 18,
                  display: "flex",
                  justifyContent: "center",
                  padding: 4,
                  background: "rgba(0,0,0,0.3)",
                }}
              >
                <Text>#{item.payload.serial} · AUCTION ENDED</Text>
              </div>
              <Title style={{ fontSize: 32 }}>
                {item.payload.bidderUserName}
              </Title>
              <Bidder style={{ marginTop: 10 }}>WON THE NFT</Bidder>
              <Subtitle style={{ marginTop: 10 }}>!glip IN CHAT</Subtitle>
            </div>
          </BoxInner>
        </Box>
        // <div style={{opacity: 1, padding: 8, paddingTop: 0, margin: 4, background: 'linear-gradient(98.93deg, rgba(0, 0, 0, 0.2) 43.21%, rgba(0, 0, 0, 0) 99.61%), linear-gradient(0deg, #000000, #000000)'}}>
        //     <div style={{}}>
        //         <Title style={{paddingTop: 6, paddingBottom: 6}}>NFT #{item.payload.serial}</Title>
        //     </div>

        //     <div style={{marginTop: 6}}>
        //         <Subtitle>{item.title}</Subtitle>
        //     </div>
        // </div>
      );
    else if (item.type == "onNewAuction")
      return (
        <Box>
          <BoxInner>
            <div
              style={{
                marginBottom: 18,
                display: "flex",
                justifyContent: "center",
                padding: 4,
                background: "rgba(0,0,0,0.3)",
              }}
            >
              <Text>NFT #{item.payload.serial} ·</Text>
              <TimerTitle
                auctionEndingAt={auctionEndingAt[item.payload.serial]}
              />
            </div>
            <Title>LIVE NFT DROPPED</Title>
            <Subtitle style={{ marginTop: 10 }}>!glip IN CHAT</Subtitle>
          </BoxInner>
        </Box>
        // <div style={{opacity: 1, padding: 8, paddingTop: 0, margin: 4, background: 'linear-gradient(98.93deg, rgba(0, 0, 0, 0.2) 43.21%, rgba(0, 0, 0, 0) 99.61%), linear-gradient(0deg, #000000, #000000)'}}>
        //      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        //         <Title style={{paddingTop: 6, paddingBottom: 6}}>NFT #{item.payload.serial}</Title>
        //         <TimerTitle auctionEndingAt={auctionEndingAt[item.payload.serial]} />
        //     </div>
        //     <div style={{marginTop: 6}}>
        //         <Subtitle>{item.title}</Subtitle>
        //     </div>
        // </div>
      );
  };

  const cards = Object.keys(glips).map((item, index) => (
    <Card key={`card-${index}`} item={glips[item]} />
  ));

  return (
    <>
      <Mobile>
        {cards}
        {/* <Box>
          <BoxInner>
            <div
              style={{
                marginBottom: 18,
                display: "flex",
                justifyContent: "center",
                padding: 4,
                background: "rgba(0,0,0,0.3)",
              }}
            >
              <Text>NFT #132 · </Text>
              <TimerTitle auctionEndingAt={new Date().getTime()} />
            </div>
            <Title style={{ fontSize: 36 }}>lightningthunder</Title>
            <Bidder style={{ marginTop: 10 }}>BID 80$</Bidder>
            <Subtitle style={{ marginTop: 10 }}>!glip IN CHAT</Subtitle>
          </BoxInner>
        </Box> */}
      </Mobile>
      <Desktop
        style={{ height: "100vh", justifyContent: "center" }}
      >
        {cards}
        <br></br>
        {/* <Box>
                    <BoxInner>
                        <div style={{marginBottom: 18, display: 'flex', justifyContent: 'center', padding: 4, background: 'rgba(0,0,0,0.3)'}}>
                            <Text>NFT #132 · </Text>
                            <TimerTitle auctionEndingAt={new Date().getTime()} />
                        </div>      
                        <Title>LIVE NFT DROPPED</Title>
                        <Subtitle style={{marginTop: 10}}>!glip IN CHAT</Subtitle>
                    </BoxInner>
                </Box> */}
        {/* <Box>
          <BoxInner>
            <div
              style={{
                marginBottom: 18,
                display: "flex",
                justifyContent: "center",
                padding: 4,
                background: "rgba(0,0,0,0.3)",
              }}
            >
              <Text>NFT #132 · </Text>
              <TimerTitle auctionEndingAt={new Date().getTime()} />
            </div>
            <Title style={{ fontSize: 36 }}>lightningthunder</Title>
            <Bidder style={{ marginTop: 10 }}>BID 80$</Bidder>
            <Subtitle style={{ marginTop: 10 }}>!glip IN CHAT</Subtitle>
          </BoxInner>
        </Box> */}
        {/* <Box winner={true}>
                    <BoxInner winner={true}>
                        <div style={{width: '100%', background: '#413321', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: 10}}>
                            <div style={{marginBottom: 18, display: 'flex', justifyContent: 'center', padding: 4, background: 'rgba(0,0,0,0.3)'}}>
                                <Text>#123 · AUCTION ENDED</Text>
                            </div>      
                            <Title style={{fontSize: 21}}>@zkartmasala</Title>
                            <Bidder style={{marginTop: 10}}>WON THE NFT</Bidder>
                            <Subtitle style={{marginTop: 10}}>!glip IN CHAT</Subtitle>
                        </div>

                    </BoxInner>
                </Box> */}
        {showMessage && (
          <PurpleBox>
            <PurpleBoxInner>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  padding: 10,
                }}
              >
                <img style={{ width: 55, marginBottom: 10 }} src={social} />
                <Title style={{ fontSize: 21 }}>
                  @{messageData.user.social.twitch}
                </Title>
                <Subtitle
                  style={{
                    marginTop: 5,
                    fontSize: 10,
                    paddingBottom: 10,
                    borderBottom: "1px solid rgba(255,255,255,.1)",
                  }}
                >
                  #{messageData.serial} NFT OWNER
                </Subtitle>
                <Message style={{ marginTop: 10 }}>
                  {messageData.message}
                </Message>
              </div>
            </PurpleBoxInner>
          </PurpleBox>
        )}
      </Desktop>
    </>
  );
}
